import styled from "styled-components";
import Button from "react-bootstrap/Button";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "../../i18n/TranslationProvider";

export const FilledSubmitButton = styled(Button)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const OutlineSubmitButton = ({
  disabled,
  onClick,
  children,
  greyout,
  type,
  style,
  className,
  centered,
  color,
}) => {
  const { t } = useTranslation();
  return (
    <div className={`submitButtonBox${centered ? " justify-content-center" : ""}`}>
      <FilledSubmitButton
        className={className ? className : "submitButton"}
        onClick={onClick}
        type={type || "button"}
        variant={`outline-${color ? color : "primary"}`}
        disabled={disabled}
        style={style}
      >
        {!greyout && disabled ? (
          <>
            <Spinner
              aria-hidden="true"
              size="sm"
              as="span"
              animation="border"
              role="status"
            />
            {t("submitbutton.saving")}
          </>
        ) : (
          children
        )}
      </FilledSubmitButton>
    </div>
  );
};

export default OutlineSubmitButton;